import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

function LifeMemberPage() {
    const [Fee, setFee] = useState(0)
    const dispatch = useDispatch();
    const history = useHistory();
    const [Type, setType] = useState("")
    const [doctype, setDoctype] = useState("")

    useEffect(() => {
        const result2 = JSON.parse(localStorage.getItem("type"))
        setType(result2)
        console.log(result2)
        if (result2 === "single") {
            setFee(1635)
            setDoctype(result2)
        }
        else {
            setFee(2670)
            setDoctype(result2)
        }

    })

    const handleRegister = () => {
        dispatch({ type: "SET_FORM_TYPE", payload: Type });
        dispatch({ type: "SET_FORM_FEE", payload: Fee });
        history.push("/MembershipFormVedio")
        
    }

    return (
        <div className="appHome">
            <h1 className="appHomeHeader">NMO Members Fees Details</h1>
            <div style={{ textAlign: 'center', height: 'auto', display: 'flex', flexDirection: 'column', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="quesCon">
                        {Fee > 0 &&
                            <div className="priceDetail">
                                <h3 style={{ background: '#fc0101', color: 'white', padding: '10px 0', borderRadius: '8px' }}>You Need to Pay ₹ {Fee}</h3>
                                <h4 style={{ textAlign: 'left', padding: '0 30px' }}>Details</h4>
                                <ul style={{ textAlign: 'left' }}>
                                    <li>Membership Fee = ₹ {doctype==="single" ?Fee-135:Fee-170}</li>
                                    <li>Online Payment Service fee of 2% on the Total</li>
                                    <li>GST on Service fee</li>
                                    <li>E-Certificate shall be sent on the provided email address.</li>
                                    <li>Hard Copy shall be sent via Courier/Speed Post.</li>
                                    <li>Pack + Courier Fee – ₹ 95 (Pan India – maximum fee)</li>
                                </ul>
                                <button className="registerBtn" onClick={handleRegister}>Register Yourself</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}



export default LifeMemberPage;
